import { useParams } from 'react-router-dom';

import { useClassroomData } from '@/data/useClassroomData';

interface AppParams {
    classroomId?: string;
    labNumber?: string;
    [key: string]: string | undefined;
}

export interface DecodedAppParams {
    classroomId?: string;
    labNumber?: number;
}

export const useDecodedParams = (): DecodedAppParams => {
    const { classroomId, labNumber } = useParams<AppParams>();
    return {
        classroomId,
        labNumber: labNumber ? parseInt(labNumber) : undefined,
    };
};

export const useParseUrlParamsForLabData = () => {
    const { classroomId, labNumber } = useDecodedParams();
    const {
        classData: { content },
    } = useClassroomData(classroomId);

    return content?.[labNumber! - 1] ?? {};
};
